<button class="mzic-tooltip" [mzicTooltip]="content"></button>
